module.exports = __webpack_public_path__ + "static/media/lilwei.fc558e3e.png";